import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RequestStatusState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: RequestStatusState = {
  data: [],
  isLoading: false,
  error: null,
};

const requestFileStatusSlice = createSlice({
  name: 'requestFileStatus',
  initialState,
  reducers: {
    setRequestFileStatuses: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setRequestFileStatusLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setRequestFileStatusError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setRequestFileStatuses, setRequestFileStatusLoading, setRequestFileStatusError } =
  requestFileStatusSlice.actions;

export default requestFileStatusSlice.reducer;
